import { render, staticRenderFns } from "./ClientMessaging.vue?vue&type=template&id=b1ab7b08&scoped=true&"
import script from "./ClientMessaging.vue?vue&type=script&lang=js&"
export * from "./ClientMessaging.vue?vue&type=script&lang=js&"
import style0 from "./ClientMessaging.vue?vue&type=style&index=0&id=b1ab7b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab7b08",
  null
  
)

export default component.exports